export default __webpack_public_path__ + "fonts/ff7e95480f99401b53788a0b40f57e927d244bcf18c4fed7d449324ee5e941a6.ttf";